// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c3vd","type":"styles_type__3YOpq","choices":"styles_choices__SIMoI"};